import { Container, Popover as BootstrapPopover } from 'react-bootstrap'
import styled from '@emotion/styled'


export const NotificationsCenterPopoverContent = styled.div({
  minWidth: '350px',
  width: 'auto !important',
  maxWidth: '600px',
  padding: '16px',
  background: '#ffffff',
  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
  borderRadius: '8px',
  display: 'flex',
  flexDirection: 'column',
})

export const NotificationsCenterHeader = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '1rem',
})

export const NotificationsCenterTitle = styled.h3({
  fontSize: '1rem',
  fontWeight: '600',
  color: '#1f2937',
})

export const NotificationsCenterScrollArea = styled.div({
  maxHeight: '400px',
  overflowY: 'auto',
})

export const NotificationsCenterSeparator = styled.hr({
  margin: 0,
  borderColor: '#e5e7eb',
})

export const NotificationsCenterFooter = styled.div({
  padding: '1rem',
  textAlign: 'center',
})

export const NotificationsCenterLoadingSpinner = styled.div(({theme})=>({
  height: '1.5rem',
  width: '1.5rem',
  borderRadius: '9999px',
  border: `2px solid ${theme.brandColorOrange}`,
  borderTopColor: 'transparent',
  animation: 'spin 1s linear infinite',
  margin: '0 auto',
}))

export const NotificationsCenterEmptyMessage = styled.p({
  fontSize: '0.875rem',
  color: '#6b7280',
})

export const NotificationItemContainer = styled.div(({ read, theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '0.75rem',
  padding: '1rem',
  borderBottom: '1px solid #f3f4f6',
  backgroundColor: read ? 'white' : `${theme.brandColorOrange}08`,
  transition: 'background-color 0.2s',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#f9fafb',
  },
}))

export const NotificationItemTitle = styled.h4(({ read , theme}) => ({
  fontSize: '0.875rem',
  fontWeight: read ? '500' : '600',
  color: read ? '#374151' : theme.brandColorOrange,
}))

export const NotificationItemMessage = styled.p({
  marginTop: '0.25rem',
  fontSize: '0.875rem',
  color: '#6b7280',
  lineHeight: '1.25',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
})

export const NotificationItemTimestamp = styled.p({
  marginTop: '0.25rem',
  fontSize: '0.75rem',
  color: '#9ca3af',
})

export const NotificationItemUnreadDot = styled.span(({theme})=>({
  width: '0.5rem',
  height: '0.5rem',
  borderRadius: '9999px',
  backgroundColor: theme.brandColorOrange,
  flexShrink: 0,
}))

export const NotificationItemIconContainer = styled.div({
  padding: '0.5rem',
  borderRadius: '9999px',
  backgroundColor: 'white',
  boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
})

export const NotificationsPageMainContainer = styled.div({
  minHeight: '100vh',
})

export const NotificationsPageStyledContainer = styled(Container)({
  paddingTop: '1rem',
  paddingBottom: '1rem',
  '@media (min-width: 640px)': {
    paddingTop: '2rem',
    paddingBottom: '2rem',
  },
})

export const NotificationsPageHeaderSection = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  marginBottom: '1.5rem',
  '@media (min-width: 640px)': {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
})

export const NotificationsPageTitle = styled.h2({
  fontSize: '1.25rem',
  fontWeight: '700',
  color: '#1f2937',
  marginBottom: '0.5rem',
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  '@media (min-width: 640px)': {
    fontSize: '1.5rem',
  },
})

export const NotificationsPageDescription = styled.p({
  fontSize: '0.875rem',
  color: '#6b7280',
  '@media (min-width: 640px)': {
    fontSize: '1rem',
  },
})

export const NotificationsPageButtonGroup = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.5rem',
  '@media (min-width: 640px)': {
    gap: '0.75rem',
  },
})

export const NotificationsPageSearchFilterSection = styled.div({
  marginBottom: '1.5rem',
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
  '@media (min-width: 640px)': {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
})

export const NotificationsPageList = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
  '@media (min-width: 640px)': {
    gap: '1rem',
  },
})

export const NotificationsPageItem = styled.div(({ read, theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '1rem',
  padding: '0.75rem',
  borderRadius: '0.5rem',
  border: '1px solid',
  borderColor: read ? '#f3f4f6' : `${theme.brandColorOrange}33`,
  backgroundColor: read ? 'white' : `${theme.brandColorOrange}0D`,
  transition: 'all 0.2s',
  '&:hover': {
    boxShadow: '0 8px 12px rgba(0, 0, 0, 0.15)',
    transform: 'scale(1.015)',
    borderColor: read ? '#e5e7eb' : `${theme.brandColorOrange}66`,
    backgroundColor: read ? '#f9fafb' : `${theme.brandColorOrange}1A`,
  },
  '@media (min-width: 640px)': {
    gap: '1.5rem',
    padding: '1rem',
  },
}))

export const NotificationsPageAvatarContainer = styled.div(({ size, theme }) => {
  return {
    width: size || '2.5rem',
    height: size || '2.5rem',
    borderRadius: '9999px',
    backgroundColor: `${theme.brandColorOrange}1A`,
    color: theme.brandColorOrange,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.875rem',
    fontWeight: '500',
    '@media (min-width: 640px)': {
      width: '3rem',
      height: '3rem',
    },
  }
})

export const NotificationsPageSkeletonItem = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: '0.75rem',
  padding: '0.75rem',
  borderRadius: '0.5rem',
  border: '1px solid #f3f4f6',
  '@media (min-width: 640px)': {
    gap: '1rem',
    padding: '1rem',
  },
})

export const NotificationsPageEmpty = styled.div({
  textAlign: 'center',
  padding: '2rem',
  backgroundColor: '#f9fafb',
  borderRadius: '0.75rem',
  border: '1px dashed #e5e7eb',
})
